module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[89]454.820ac24.woff2";